export default __webpack_public_path__ + "static/media/mint_info.94be436a.png";